export default __webpack_public_path__ + "static/media/activity-icon.ca7d9ef0.svg";